import React from 'react';

class About extends React.Component {

  render() {
    return (
      <div>
        <h1>When I am grown up I will be an About page!</h1>
      </div>
    );
  }

}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js